import React from "react";
import { cn } from "../../DashboardPage/lib/utils";
import Breadcrumbs, { BreadcrumbItem } from "./Breadcrumbs";

interface PageHeaderProps {
  title: React.ReactNode;
  /** Optional supporting line under the title. */
  description?: React.ReactNode;
  /** Buttons / controls aligned to the trailing edge. */
  actions?: React.ReactNode;
  /**
   * Trail shown above the title, starting from HOME_CRUMB. Every page has one,
   * so it replaces the old "← Back" links.
   */
  breadcrumbs?: BreadcrumbItem[];
  className?: string;
}

/**
 * Canonical page title block: breadcrumb trail on top, then title on the
 * leading edge and actions trailing, stacking to a column on small screens.
 */
export default function PageHeader({
  title,
  description,
  actions,
  breadcrumbs,
  className,
}: PageHeaderProps) {
  return (
    <div className={className}>
      {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumbs items={breadcrumbs} />}
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
        <div className="min-w-0">
          <h2 className="text-xl font-semibold tracking-tight text-black sm:text-2xl">
            {title}
          </h2>
          {description && (
            <p className="mt-1 text-sm text-neutral-600">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-col w-full gap-3 sm:flex-row sm:w-auto">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
